import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var chunkChildren = function chunkChildren(childrenArray, size) {
  var chunkedChildren = [];
  var numChunks = Math.ceil(childrenArray.length / size);
  for (var i = 0; i < numChunks; i++) {
    var start = i * size;
    var end = start + size;
    var chunk = childrenArray.slice(start, end);
    while (chunk && chunk.length < size) {
      chunk.push( /*#__PURE__*/_jsx("div", {
        className: "blank-item"
      }, "blank-".concat(chunk.length)));
    }
    chunkedChildren.push(chunk);
  }
  return chunkedChildren;
};